import React from "react";
import { IonCol, IonIcon, IonLabel, IonRow } from "@ionic/react";

import styles from "./Tabs.module.scss";

import { useHistory, useLocation } from "react-router-dom";
import classNames from "classnames/bind";
import { useAuth } from "../../../../contexts/auth-context";
import { homeIcon, catalogIcon, basketIcon, heartIcon, personIcon } from "@core/icons";
import { useCartData } from "../../../../providers/cartDataStore";

import { useConfig } from "../../../../providers/config";
import { useTranslation } from "react-i18next";

interface TabItem {
  icon: string;
  route: string;
  altRoute?: string;
  text: string;
  notification?: number;
  onClick: () => void;
}

const cx = classNames.bind(styles);

const Tabs: React.FC = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const { pathname } = useLocation();
  const history = useHistory();
  const { user } = useAuth();

  const { cartTotalValue, cartProducts } = useCartData();

  const items: TabItem[] = [
    {
      text: t("Home"),
      icon: homeIcon,
      route: "/home",
      onClick: () => history.push("/home3"),
    },
    {
      text: t("Catalog"),
      icon: catalogIcon,
      route: "/search-main-categories",
      onClick: () => history.push("/search-main-categories"),
    },
    {
      text: cartTotalValue.toFixed(2) + " ₽",
      icon: basketIcon,
      route: "/cart",
      notification: cartProducts.reduce((acc, item) => item.quantity + acc, 0),
      onClick: () => history.push("/cart"),
    },
    {
      text: t("Favorite"),
      icon: heartIcon,
      route: "/wish-list",
      onClick: () => history.push("/wish-list"),
    },
    {
      text: t("Profile"),
      icon: personIcon,
      route: "/my-account",
      altRoute: "/auth",
      onClick: () => {
        if (!user) {
          history.push("/auth");
        } else {
          history.push("/my-account");
        }
      },
    },
  ];

  if (!config.haveTabs) {
    return null;
  }

  return (
    <IonRow>
      <div className={cx("tabs", "ion-hide-md-up")}>
        {items.map((x) => {
          const isActive = pathname.startsWith(x.route) || pathname.startsWith(x.altRoute as any);
          return (
            <IonCol key={x.route} size="2.4" onClick={x.onClick}>
              <div className={cx("item")}>
                <div className={cx("iconContainer")}>
                  <IonIcon src={x.icon} className={cx(`${isActive ? "iconActive" : "icon"}`)} />
                  {x.notification !== undefined && (
                    <div className={cx("notification")}>
                      <span className={cx("notificationCounter")}>{x.notification}</span>
                    </div>
                  )}
                </div>
                <IonLabel className={isActive ? cx("activeLabel") : cx("label")}>{x.text}</IonLabel>
              </div>
            </IonCol>
          );
        })}
      </div>
    </IonRow>
  );
};

export default Tabs;
